import { Author } from "interface/Author";
import linda from "assets/images/jpg/Linda.jpeg";


/**
 * LindaArthur is an object representing the author Linda Arthur with her details.
 * 
 * @constant {Author}
 * 
 * @property {string} name - The name of the author.
 * @property {string} imageUrl - The URL of the author's profile image.
 * @property {string} role - The professional role or expertise of the author.
 * @property {string} href - The link to the author's LinkedIn profile.
 * 
 * @example
 * import { LindaArthur } from "path/to/author";
 * 
 * console.log(LindaArthur.name); // Outputs: "Linda Arthur"
 */
export const LindaArthur: Author = {
    name: "Linda Arthur",
    imageUrl: linda,
    role: "Data Analyst, Zerone Analytiqs",
    href: "/"
}